import React ,{useState,useEffect}from 'react'

  import {
    Box,
   
    Button,
   
  } from "@mui/material";
import BuyerNegotiaiteAdmin from 'features/masterdata/common/MobileProcurementBuyer/BuyerNegotiaiteAdmin';
import FarmerNegotiationAdmin from './FarmerNegotiationAdmin';
export const FarmerAdminNegotiation = ({tradeData,organizationVal,setactiveNegotiation, activeNegotiation}) => {
    // const[activeNegotiation,setactiveNegotiation]=useState("ByBuyer")
  

  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 3 }}>
      <Button
        variant={activeNegotiation === "ByFarmer" ? "contained" : "outlined"}
        onClick={() => setactiveNegotiation("ByFarmer")}
        sx={{
          minWidth: "150px",
          textTransform: "none",
          color: activeNegotiation === "ByFarmer" ? "#FFFFFF" : "#FF9800",
          backgroundColor: activeNegotiation === "ByFarmer" ? "#FF9800" : "transparent",
          borderColor: "#FF9800",
          "&:hover": {
            backgroundColor: activeNegotiation === "ByFarmer" ? "#F57C00" : "#FF9800",
            color: "#FFFFFF",
          },
        }}
      >
       Negotiate With Farmer
      </Button>
      <Button
        variant={activeNegotiation === "ByBuyer" ? "contained" : "outlined"}
        onClick={() => setactiveNegotiation("ByBuyer")}
        sx={{
          minWidth: "150px",
          textTransform: "none",
          color: activeNegotiation === "ByBuyer" ? "#FFFFFF" : "#FF9800",
          backgroundColor: activeNegotiation === "ByBuyer" ? "#FF9800" : "transparent",
          borderColor: "#FF9800",
          "&:hover": {
            backgroundColor: activeNegotiation === "ByBuyer" ? "#F57C00" : "#FF9800",
            color: "#FFFFFF",
          },
        }}
      >
       Negotiate With Buyer
      </Button>

      
    </Box>

  {activeNegotiation==="ByBuyer"?
  <BuyerNegotiaiteAdmin trade={tradeData}  type="Admin" organizationVal={organizationVal}/>:
  <FarmerNegotiationAdmin trade={tradeData}  type="Admin" organizationVal={organizationVal}/>
  }

    </div>
  )
}
